/* perf 30.09 D-10: skrypt popupu SV „wybór celu” wyniesiony z sections/sv-goal-popup.liquid (36 KB inline w HTML każdej
   strony -> plik z pamięci przeglądarki, defer). Konfiguracja bez zmian: atrybuty data-* korzenia sekcji. Kod 1:1 z sekcją
   (LIVE 30.09 + łatka J = B-14); jedyne zmiany: {{ section.id }} -> SECTION_ID z id korzenia oraz IIFE -> init(root)
   wołane dla każdego [data-svgp-root] (+ ponownie po shopify:section:load w edytorze motywu).
   Kolejność: start i tak czeka na requestIdleCallback (do 2,5 s), hak fetch ponawia się przy DOMContentLoaded/load. */
(function () {
  function initSvGoalPopup(root) {
  if (!root || root.dataset.svgpBooted) return;
  root.dataset.svgpBooted = '1';
  var SECTION_ID = root.id.replace(/^SvGoalPopup-/, '');

  var KEY_HIDE = 'sv_popup_v1_hide_until';
  var KEY_DONE = 'sv_popup_v1_done';
  var KEY_TEASER_OFF = 'sv_popup_v1_teaser_off'; /* sessionStorage: ✕ na zakładce = cisza do końca sesji (12.09) */
  var KEY_AB = 'sv_popup_ab';
  var KEY_TEASER_AB = 'sv_teaser_ab'; /* test wyglądu teasera 02.10.2026: 'tab' (zakładka) | 'corner' (narożnik) */
  var KEY_OFFER_AB = 'sv_offer_ab'; /* test oferty Black Week 20.10.2026: 'std' (obecne -5%) | 'bw' (-5% + Black Week wcześniej) */
  var ENABLED = root.getAttribute('data-enabled') === 'true';
  var MODE = root.getAttribute('data-trigger-mode') || 'teaser_first';
  var TEASER_DELAY = parseInt(root.getAttribute('data-teaser-delay'), 10);
  if (isNaN(TEASER_DELAY)) TEASER_DELAY = 2;
  var SKIP_IDENTIFIED = root.getAttribute('data-skip-identified') === 'true';
  var DELAY = parseInt(root.getAttribute('data-delay'), 10);
  var DELAY_M = parseInt(root.getAttribute('data-delay-mobile'), 10);
  var SCROLL_PCT = parseInt(root.getAttribute('data-scroll'), 10);
  var EXIT_INTENT = root.getAttribute('data-exit-intent') === 'true';
  var CAP_DAYS = parseInt(root.getAttribute('data-cap-days'), 10) || 7;
  var WAIT_CONSENT = root.getAttribute('data-wait-consent') === 'true';
  var AB_ENABLED = root.getAttribute('data-ab-enabled') === 'true';
  var B_SHARE = parseInt(root.getAttribute('data-b-share'), 10);
  if (isNaN(B_SHARE)) B_SHARE = 50;
  var FLYOUT_ID = root.getAttribute('data-flyout-id') || '';
  var KL_COMPANY = root.getAttribute('data-kl-company') || '';
  var KL_LIST = root.getAttribute('data-kl-list') || '';
  var KL_SMS_LIST = root.getAttribute('data-kl-sms-list') || '';
  var V_EMAIL = root.getAttribute('data-consent-email-version') || '';
  var V_PHONE = root.getAttribute('data-consent-phone-version') || '';
  var OFFER = root.getAttribute('data-offer') || '';
  var CORNER_SHARE = parseInt(root.getAttribute('data-teaser-corner-share'), 10);
  if (isNaN(CORNER_SHARE)) CORNER_SHARE = 0;
  /* test oferty Black Week (20.10.2026): udział 0 albo brak formularza B = wszyscy obecna oferta (stan domyślny);
     działa tylko między offer_bw_start a offer_bw_end (czas przeglądarki, daty ISO ze strefą) */
  var OFFER_SHARE = parseInt(root.getAttribute('data-offer-bw-share'), 10);
  if (isNaN(OFFER_SHARE)) OFFER_SHARE = 0;
  var OFFER_FLYOUT = root.getAttribute('data-offer-bw-flyout-id') || '';
  var OFFER_START = Date.parse(root.getAttribute('data-offer-bw-start') || '');
  var OFFER_END = Date.parse(root.getAttribute('data-offer-bw-end') || '');
  function splitPaths(s) {
    return (s || '').split(',').map(function (x) { return x.trim().toLowerCase().replace(/\/+$/, ''); }).filter(Boolean);
  }
  var EXCLUDE = splitPaths(root.getAttribute('data-exclude'));
  var TEST_EXCLUDE = splitPaths(root.getAttribute('data-test-exclude'));

  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var params = new URLSearchParams(window.location.search);
  var FORCE = (params.get('sv_popup') || '').toLowerCase();
  var FORCE_TEASER = (params.get('sv_teaser') || '').toLowerCase();
  var FORCE_OFFER = (params.get('sv_offer') || '').toLowerCase();
  /* 28.10.2026: druga faza grupy bw od offer_bw2_start (jedna promocja Black Weeks 03.11-31.12 zamiast Early Black
     i Black Week): inny formularz B i inny dopisek na narożniku, losowanie, przydział i okno testu bez zmian; czas
     przeglądarki przy wczytaniu strony. Podgląd drugiej fazy przed datą: ?sv_offer=bw&sv_offer_faza=2 */
  var OFFER2_FLYOUT = root.getAttribute('data-offer-bw2-flyout-id') || '';
  var OFFER2_START = Date.parse(root.getAttribute('data-offer-bw2-start') || '');
  var OFFER2_TEASER = root.getAttribute('data-offer-bw2-teaser') || '';
  var OFFER_PHASE2 = !!OFFER2_FLYOUT && (params.get('sv_offer_faza') === '2' || (!isNaN(OFFER2_START) && Date.now() >= OFFER2_START));
  if (OFFER_PHASE2) OFFER_FLYOUT = OFFER2_FLYOUT;
  var IS_MOBILE = window.innerWidth < 750;
  var FINE_POINTER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function ls(fn, dflt) { try { return fn(); } catch (e) { return dflt; } }
  function getLS(k) { return ls(function () { return window.localStorage.getItem(k); }, null); }
  function setLS(k, v) { ls(function () { window.localStorage.setItem(k, v); }); }
  function delLS(k) { ls(function () { window.localStorage.removeItem(k); }); }
  if (FORCE === 'reset') { delLS(KEY_HIDE); delLS(KEY_DONE); delLS(KEY_AB); delLS(KEY_TEASER_AB); delLS(KEY_OFFER_AB); }

  function pathMatches(list) {
    var p = window.location.pathname.toLowerCase().replace(/\/+$/, '');
    p = p.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/, '');
    /* karta produktu otwarta z kolekcji (/collections/sklep/products/x) = ten sam produkt co /products/x (29.10: okienko -5% na e-karcie) */
    p = p.replace(/^\/collections\/[^\/]+(?=\/products\/)/, '');
    if (p === '') p = '/';
    for (var i = 0; i < list.length; i++) {
      var e = list[i];
      if (p === e || p.indexOf(e + '/') === 0) return true;
    }
    return false;
  }
  var EXCLUDED = pathMatches(EXCLUDE);
  var TEST_EXCLUDED = pathMatches(TEST_EXCLUDE);

  /* ── wariant A/B ──
     A = flyout Klaviyo (custom trigger), B = ten fullscreen. Sticky w localStorage.
     Udział B 0 = wszyscy A (kill switch), 100 = wszyscy B. A/B wyłączone = wszyscy B.
     Ścieżki testowo wykluczone (blog) = A bez losowania (cohort 'excluded'). */
  var COHORT = TEST_EXCLUDED ? 'excluded' : 'test';
  function pickVariant() {
    if (FORCE === 'a') return 'A';
    if (FORCE === 'b') return 'B';
    if (!AB_ENABLED) return 'B';
    if (TEST_EXCLUDED) return 'A';
    if (B_SHARE <= 0) return 'A';
    if (B_SHARE >= 100) return 'B';
    var stored = getLS(KEY_AB);
    if (stored === 'A' || stored === 'B') return stored;
    var v = (Math.random() * 100) < B_SHARE ? 'B' : 'A';
    setLS(KEY_AB, v);
    track('sv_popup_assigned', { variant: v });
    return v;
  }
  var VARIANT = null;

  var state = { open: false, email: '', goal: '', lastFocus: null, shown: false, pendingOpenReason: '' };
  /* ── Consentmo: nie nakładamy popupu na baner cookie (baner = popover w top layer, nad wszystkim).
     Decyzja = cookie `cookieconsent_status` (allow/deny/dismiss). Brak Consentmo po 4 s = nie czekamy.
     Dotyczy OBU wariantów (parytet). Podgląd ?sv_popup=a|b otwiera od razu (bez czekania). ── */
  var consentT0 = Date.now(), consentWaiters = [], consentPoll = null;
  function consentDecided() {
    if (!WAIT_CONSENT) return true;
    try { if (/(^|;\s*)cookieconsent_status=/.test(document.cookie)) return true; } catch (e) { return true; }
    var el = document.querySelector('csm-cookie-consent');
    if (!el && Date.now() - consentT0 > 4000) return true;
    return Date.now() - consentT0 > 600000;
  }
  function onConsentDecided(cb) {
    consentWaiters.push(cb);
    if (consentPoll) return;
    consentPoll = setInterval(function () {
      if (!consentDecided()) return;
      clearInterval(consentPoll); consentPoll = null;
      consentWaiters.splice(0).forEach(function (f) { try { f(); } catch (e) {} });
    }, 250);
  }
  var teaserShownTracked = false;
  function teaserOffThisSession() {
    try { return window.sessionStorage.getItem(KEY_TEASER_OFF) === '1'; } catch (e) { return false; }
  }
  /* ── test A/B WYGLĄDU teasera (02.10.2026): zakładka boczna (12.09) kontra narożnik (klin Klaviyo sprzed 12.09) ──
     Zmienia się WYŁĄCZNIE wygląd i miejsce teasera; flyout, triggery, ✕ = cisza na sesję, cap, wykluczenia i fallback
     adblock są wspólne. Losujemy przy PIERWSZYM pokazaniu teasera (mianownik = osoby, które teaser zobaczyły), sticky
     w localStorage. Udział 0 = wszyscy zakładka (bez zapisu), 100 = wszyscy narożnik (bez zapisu), jak przy sv_popup_ab.
     Podgląd bez zapisu: ?sv_teaser=corner|tab. Grupa idzie do GA4 (parametr `teaser` przy każdym sv_popup_*), do
     Klaviyo (popup_teaser w „SkinVibe Popup Signup”) i do koszyka (atrybut sv_teaser): trzy niezależne liczniki. */
  var TEASER_STYLE = '', TEASER_NOSTORE = false;
  function teaserTestOn() { return CORNER_SHARE > 0 && CORNER_SHARE < 100; }
  function storedTeaserStyle() {
    var s = getLS(KEY_TEASER_AB);
    return (s === 'tab' || s === 'corner') ? s : '';
  }
  function pickTeaserStyle() {
    if (FORCE_TEASER === 'corner' || FORCE_TEASER === 'tab') return FORCE_TEASER;
    if (CORNER_SHARE <= 0) return 'tab';
    if (CORNER_SHARE >= 100) return 'corner';
    var s = storedTeaserStyle();
    if (s) return s;
    var v = (Math.random() * 100) < CORNER_SHARE ? 'corner' : 'tab';
    setLS(KEY_TEASER_AB, v);
    /* recenzja B4: zablokowany localStorage = losowanie na każdej stronie od nowa -> taka osoba widzi zakładkę i jest poza testem */
    if (storedTeaserStyle() !== v) { TEASER_NOSTORE = true; return 'tab'; }
    TEASER_STYLE = v;
    track('sv_popup_teaser_assigned', { teaser: v });
    return v;
  }
  /* parametr `teaser` w analityce: grupa testu albo etykieta poza testem (podgląd ?sv_teaser= -> preview_*, brak zapisu
     w localStorage -> nostore), żeby odczyt testu liczył wyłącznie prawdziwe przydziały (recenzja B3) */
  function applyTeaserStyle(v) {
    TEASER_STYLE = TEASER_NOSTORE ? 'nostore' : (FORCE_TEASER === v ? 'preview_' + v : v);
    teaser.classList.toggle('svgp__teaser--corner', v === 'corner');
  }
  /* ── test A/B OFERTY (20.10.2026): obecne „-5%” (std) kontra „-5% + dostęp do Black Week dzień wcześniej” (bw) ──
     Zmienia się WYŁĄCZNIE obietnica: dopisek na narożniku i formularz Klaviyo (OFFER_FLYOUT = kopia SHvwGT z innym
     tekstem); wygląd, wyzwalacze, ✕, cap i wykluczenia są wspólne. Losujemy przy pierwszym pokazaniu teasera albo
     otwarciu przez automat, sticky w localStorage, tylko w oknie dat (po jego końcu wszyscy std, przydział zostaje
     w pamięci, ale nic nie zmienia). Udział 100 = wszyscy bw bez zapisu. Podgląd bez zapisu (niezależnie od dat):
     ?sv_offer=bw|std. Grupa idzie do GA4 (parametr `offer`), do Klaviyo (popup_offer_arm, a dla bw popup_offer
     bw_early) i do koszyka (atrybut sv_offer, tylko w trakcie testu i z zapisanego losowania). */
  var OFFER_ARM = '', OFFER_PICKED = '';
  function offerWindowOn() {
    var now = Date.now();
    return !!OFFER_FLYOUT && OFFER_SHARE > 0 && !isNaN(OFFER_START) && !isNaN(OFFER_END) && now >= OFFER_START && now < OFFER_END;
  }
  function offerTestOn() { return offerWindowOn() && OFFER_SHARE < 100; }
  function storedOffer() {
    var s = getLS(KEY_OFFER_AB);
    return (s === 'bw' || s === 'std') ? s : '';
  }
  function pickOffer() {
    if (OFFER_PICKED) return OFFER_PICKED;
    var v = 'std';
    if ((FORCE_OFFER === 'bw' && OFFER_FLYOUT) || FORCE_OFFER === 'std') { v = FORCE_OFFER; OFFER_ARM = 'preview_' + v; }
    else if (!offerWindowOn()) { OFFER_ARM = ''; }
    else if (OFFER_SHARE >= 100) { v = 'bw'; OFFER_ARM = 'bw'; }
    else {
      var s = storedOffer();
      if (s) { v = s; OFFER_ARM = s; }
      else {
        v = (Math.random() * 100) < OFFER_SHARE ? 'bw' : 'std';
        setLS(KEY_OFFER_AB, v);
        /* jak przy teaserze (recenzja B4): zablokowany localStorage = poza testem, obecna oferta */
        if (storedOffer() !== v) { v = 'std'; OFFER_ARM = 'nostore'; }
        else { OFFER_ARM = v; track('sv_popup_offer_assigned', { offer: v }); }
      }
    }
    OFFER_PICKED = v;
    teaser.classList.toggle('svgp__teaser--bw', v === 'bw');
    return v;
  }
  /* formularz do otwarcia: B tylko dla grupy bw i tylko w oknie dat (strona otwarta przed końcem okna nie otworzy już B) */
  function offerFlyoutId() {
    return (pickOffer() === 'bw' && (FORCE_OFFER === 'bw' || offerWindowOn())) ? OFFER_FLYOUT : FLYOUT_ID;
  }
  var ACTIVE_FLYOUT = '';
  /* Narożnik a pasek „Dodaj do koszyka” (sv-sticky-atc.js, klasa .show): gdy pasek leży pod prawym rogiem (telefon),
     narożnik unosi się nad niego (--svgp-lift) tą samą krzywą i czasem co pasek; na komputerze pasek stoi na środku
     i narożnik zostaje w rogu. Gdy w dolny pas ekranu (20 %, min. 140 px) wjeżdża GŁÓWNY przycisk „Dodaj do koszyka”
     (pasek jest wtedy schowany), narożnik ustępuje (--yield). Startuje dopiero przy pokazaniu narożnika (recenzja B2).
     Wydajność (lekcja perf 30.09 B-04): bez nasłuchu scroll/resize i bez odczytów układu w trakcie przewijania:
     MutationObserver tylko na klasie paska (powtórki tej samej klasy pomijane), jeden odczyt pozycji paska po jego
     animacji i po narysowaniu klatki, IntersectionObserver z rootMargin (szerokość z rootBounds, nie z window). */
  var cornerReady = false, cornerLift = -1, onCornerLift = null;
  var GEO_KEY = 'sv_teaser_bargeo_' + (IS_MOBILE ? 'm' : 'd');
  function setCornerLift(px) {
    if (px === cornerLift) return;
    cornerLift = px;
    teaser.style.setProperty('--svgp-lift', px + 'px');
    if (onCornerLift) onCornerLift();
  }
  function initCorner() {
    if (cornerReady) return;
    cornerReady = true;
    setCornerLift(0);
    try {
      var bar = document.querySelector('.sticky-atc');
      if (bar && window.MutationObserver) {
        /* Pozycję paska czytamy dopiero, gdy stoi (po jego animacji .4 s): prostokąt w trakcie wjazdu jest przesunięty,
           a offsetTop dla position:fixed Safari liczy od początku dokumentu (testy 02.10). Geometria (odległość paska
           od dołu i od prawej krawędzi) jest pamiętana w sessionStorage, więc od drugiej karty narożnik rusza RAZEM
           z paskiem (recenzja B6); bez pamięci narożnik czeka niewidoczny (--wait), aż pasek stanie, zamiast na chwilę
           zasłonić jego przycisk. */
        var barGeo = sess(function () { return JSON.parse(window.sessionStorage.getItem(GEO_KEY) || 'null'); }, null);
        var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null, lastKey = '';
        var liftFrom = function (g) {
          var vh = window.innerHeight;
          /* narożnik STOI na górnej krawędzi paska (ramka karty paska = jego prostokąt), bez szczeliny: CEO 02.10 —
             8 px odstępu wyglądało, jakby narożnik wisiał w powietrzu */
          setCornerLift((g && g.rightGap < 120 && g.dist > 0 && g.dist < vh / 2) ? Math.round(g.dist) : 0);
        };
        var unwait = function () { afterPaint(function () { teaser.classList.remove('svgp__teaser--wait'); }); };
        var whenStill = function (cb) {
          var done = false;
          var go = function () { if (done) return; done = true; afterPaint(cb); };
          var anims = null;
          try { anims = bar.getAnimations ? bar.getAnimations() : null; } catch (e) { anims = null; }
          if (anims === null || !window.Promise) { setTimeout(go, 450); return; }
          if (!anims.length) { go(); return; }
          Promise.all(anims.map(function (a) { return a.finished; })).then(go, go);
          setTimeout(go, 600); /* recenzja C5: bez wiecznego czekania, gdyby pasek dostał kiedyś nieskończoną animację */
        };
        var onBar = function () {
          var shown = bar.classList.contains('show');
          var key = (shown ? '1' : '0') + (mq && mq.matches ? 'm' : 'd');
          if (key === lastKey) return; /* recenzja C1: sv-sticky-atc.js dodaje tę samą klasę kilka razy */
          lastKey = key;
          if (!shown) { setCornerLift(0); teaser.classList.remove('svgp__teaser--wait'); return; }
          if (barGeo) liftFrom(barGeo); else teaser.classList.add('svgp__teaser--wait');
          whenStill(function () {
            if (!bar.classList.contains('show')) { teaser.classList.remove('svgp__teaser--wait'); return; }
            var r = bar.getBoundingClientRect();
            /* clientWidth bez paska przewijania (recenzja C2); układ jest tu policzony, odczyt nic nie kosztuje */
            barGeo = { dist: window.innerHeight - r.top, rightGap: document.documentElement.clientWidth - r.right };
            sess(function () { window.sessionStorage.setItem(GEO_KEY, JSON.stringify(barGeo)); });
            liftFrom(barGeo);
            unwait();
          });
        };
        new MutationObserver(function () { afterPaint(onBar); }).observe(bar, { attributes: true, attributeFilter: ['class'] });
        onBar(); /* od razu, zanim narożnik się pokaże: z pamięci uniesiony albo czeka niewidoczny */
      }
      /* narożnik ustępuje, gdy pod nim jest coś do dotknięcia: główny przycisk zakupu albo rząd miniatur galerii */
      var yieldBy = {};
      var setYield = function (k, on) {
        yieldBy[k] = on;
        teaser.classList.toggle('svgp__teaser--yield', !!(yieldBy.atc || yieldBy.gal));
      };
      var btns = document.querySelectorAll('[id^="ProductSubmitButton-"]'), atc = null;
      for (var i = 0; i < btns.length; i++) {
        if (!btns[i].closest('.sticky-atc')) { atc = btns[i].closest('.product-form__buttons') || btns[i]; break; }
      }
      if (atc && window.IntersectionObserver) {
        /* pas ustępowania: dolne 20 % ekranu, ale nie mniej niż 140 px (niskie ekrany, recenzja B5); start w stanie
           ustąpienia, pierwszy wynik obserwatora ustawia właściwy (recenzja B7: bez mignięcia nad przyciskiem) */
        var bandPct = Math.min(60, Math.max(20, Math.ceil(140 / Math.max(1, window.innerHeight) * 100)));
        setYield('atc', true);
        new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          var vw = e.rootBounds ? e.rootBounds.right : document.documentElement.clientWidth;
          setYield('atc', e.isIntersecting && e.boundingClientRect.right > vw - 120);
        }, { root: null, rootMargin: '-' + (100 - bandPct) + '% 0px 0px 0px', threshold: 0 }).observe(atc);
      }
      /* 18.10: rząd miniatur galerii 3.0 (wariant „thumbs” testu galerii) na wyższych telefonach leży pod narożnikiem
         uniesionym na pasek ATC i dotknięcie ostatniej miniatury otwierało popup (e2e --po-tescie, Pixel 7). Narożnik
         ustępuje, gdy rząd wchodzi w jego prostokąt (prawe 130 px, od 10 px nad narożnikiem do jego dolnej krawędzi =
         górnej krawędzi paska, gdy jest uniesiony; miniatury pod samym paskiem go nie chowają). Prostokąt zależy od
         uniesienia, więc obserwator powstaje od nowa przy każdej zmianie uniesienia (kilka razy na stronę, bez
         odczytów układu). Wariant „dots” ma rząd schowany (display none = brak przecięcia), komputer ma miniatury
         z lewej, poza prostokątem. */
      var thumbs = document.querySelector('media-gallery [id^="GalleryThumbnails-"]'), galIO = null;
      if (thumbs && window.IntersectionObserver) {
        var watchThumbs = function () {
          if (galIO) galIO.disconnect();
          var vw = document.documentElement.clientWidth, vh = window.innerHeight, lift = Math.max(0, cornerLift);
          galIO = new IntersectionObserver(function (entries) {
            setYield('gal', entries[entries.length - 1].isIntersecting);
          }, { root: null, rootMargin: '-' + Math.max(0, vh - lift - 130) + 'px 0px -' + lift + 'px -' + Math.max(0, vw - 130) + 'px', threshold: 0 });
          galIO.observe(thumbs);
        };
        setYield('gal', true);
        onCornerLift = watchThumbs;
        watchThumbs();
      }
    } catch (e) {}
  }
  function showTeaser() {
    if (EXCLUDED || getLS(KEY_DONE) === '1' || teaserOffThisSession()) return;
    if (!consentDecided()) { onConsentDecided(showTeaser); return; }
    if (!TEASER_STYLE) applyTeaserStyle(pickTeaserStyle());
    pickOffer();
    if (teaser.classList.contains('svgp__teaser--corner')) initCorner();
    teaser.hidden = false;
    ghostBurst();
    if (!teaserShownTracked) { teaserShownTracked = true; track('sv_popup_teaser', { action: 'shown' }); }
  }
  var panel = root.querySelector('[data-svgp-panel]');
  var teaser = document.getElementById('SvGoalTeaser-' + SECTION_ID);
  /* druga faza testu oferty: dopisek grupy bw z offer_bw2_teaser (| = nowa linia), widoczność dalej z klasy --bw */
  var teaserBw = OFFER_PHASE2 && OFFER2_TEASER && teaser ? teaser.querySelector('.svgp__teaser-bw') : null;
  if (teaserBw) {
    teaserBw.textContent = '';
    OFFER2_TEASER.split('|').forEach(function (line, i) {
      if (i) teaserBw.appendChild(document.createElement('br'));
      teaserBw.appendChild(document.createTextNode(line));
    });
  }
  var steps = {};
  root.querySelectorAll('[data-svgp-step]').forEach(function (el) {
    steps[el.getAttribute('data-svgp-step')] = el;
  });

  /* ── analityka: GA4 (własny config na strumień) + web pixels + dataLayer ── */
  var GA4_ID = root.getAttribute('data-ga4') || '';
  var ga4Ready = false, ga4Queue = [], ga4Poll = null, ga4Tries = 0;
  function ga4Config() {
    if (ga4Ready) return;
    window.gtag('config', GA4_ID, { send_page_view: false });
    ga4Ready = true;
  }
  /* gtag wstrzykuje kanał Google & YouTube z opóźnieniem (QA 25.08: open po 2 s ginął) →
     wczesne wywołania czekają w kolejce i lecą, gdy gtag się pojawi (max ~15 s) */
  function ga4Flush() {
    if (typeof window.gtag !== 'function') return false;
    ga4Config();
    while (ga4Queue.length) { var q = ga4Queue.shift(); window.gtag.apply(null, q); }
    return true;
  }
  function ga4Send(args) {
    if (!GA4_ID) return;
    ga4Queue.push(args);
    if (ga4Flush() || ga4Poll) return;
    ga4Poll = setInterval(function () {
      ga4Tries++;
      if (ga4Flush() || ga4Tries > 60) { clearInterval(ga4Poll); ga4Poll = null; }
    }, 250);
  }
  function ga4(name, data) { ga4Send(['event', name, Object.assign({ send_to: GA4_ID }, data || {})]); }
  function ga4UserVariant(v) { if (v) ga4Send(['set', 'user_properties', { popup_variant: v }]); }
  /* perf 30.09 B-14 (wzorzec Shopify „yield to main thread”, docs: debounce-throttle-event-handlers): analityka po narysowaniu
     klatki. Dotknięcie najpierw zmienia ekran, a dataLayer/gtag/Shopify.analytics idą w następnym zadaniu (lab 30.09 ×4:
     jeden track() = 20–25 ms, do ~70 ms). Karta w tle (rAF wstrzymany) = od razu. */
  function afterPaint(cb) {
    if (document.hidden || typeof requestAnimationFrame !== 'function') { cb(); return; }
    requestAnimationFrame(function () { setTimeout(cb, 0); });
  }
  function track(name, data) {
    var payload = Object.assign({ variant: VARIANT || '', cohort: COHORT, teaser: TEASER_STYLE || '', offer: OFFER_ARM || '' }, data || {});
    afterPaint(function () { trackNow(name, payload); });
  }
  function trackNow(name, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
    try { ga4(name, payload); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('skinvibe_' + name.replace(/^sv_/, ''), payload);
      }
    } catch (e) {}
  }

  /* first-touch UTM sesji */
  var UTM_KEY = 'sv_popup_utm_v1';
  (function captureUtm() {
    try {
      if (window.sessionStorage.getItem(UTM_KEY)) return;
      var u = {};
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) {
        var v = params.get(k); if (v) u[k] = v;
      });
      if (Object.keys(u).length) window.sessionStorage.setItem(UTM_KEY, JSON.stringify(u));
    } catch (e) {}
  })();
  function utmProps() {
    try {
      var u = JSON.parse(window.sessionStorage.getItem(UTM_KEY) || '{}');
      var out = {};
      if (u.utm_source) out.popup_utm_source = u.utm_source;
      if (u.utm_medium) out.popup_utm_medium = u.utm_medium;
      if (u.utm_campaign) out.popup_utm_campaign = u.utm_campaign;
      return out;
    } catch (e) { return {}; }
  }

  function go(name) {
    Object.keys(steps).forEach(function (k) { steps[k].classList.toggle('is-active', k === name); });
    var h = steps[name] && steps[name].querySelector('.svgp__title');
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    track('sv_popup_step', { step_name: name });
  }

  var prevOverflow = '';
  function lockScroll(on) {
    var de = document.documentElement;
    if (on) { prevOverflow = de.style.overflow; de.style.overflow = 'hidden'; }
    else { de.style.overflow = prevOverflow; }
  }
  function trapFocus(e) {
    if (!state.open || e.key !== 'Tab') return;
    var els = panel.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])');
    var vis = [].filter.call(els, function (el) { return el.offsetParent !== null; });
    if (!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }

  function setHideCap() {
    if (getLS(KEY_DONE) === '1') return;
    setLS(KEY_HIDE, String(Date.now() + CAP_DAYS * 864e5));
  }

  /* ── wariant B: nasz fullscreen ── */
  function openB(reason) {
    if (state.open) return;
    state.open = true; state.shown = true;
    state.lastFocus = document.activeElement;
    root.classList.add('is-open');
    teaser.hidden = true;
    lockScroll(true);
    document.addEventListener('keydown', onKey);
    var h = panel.querySelector('.svgp__step.is-active .svgp__title');
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
    track('sv_popup_open', { reason: reason || 'auto' });
  }
  function closeB(reason) {
    if (!state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    lockScroll(false);
    document.removeEventListener('keydown', onKey);
    if (state.lastFocus && state.lastFocus.focus) { try { state.lastFocus.focus(); } catch (e) {} }
    if (getLS(KEY_DONE) !== '1') {
      setHideCap();
      showTeaser();
    }
    track('sv_popup_close', { reason: reason || 'x' });
  }
  function markDone() { setLS(KEY_DONE, '1'); }
  function onKey(e) {
    if (e.key === 'Escape') { closeB('esc'); return; }
    trapFocus(e);
  }

  /* ── wariant A: flyout Klaviyo przez custom trigger ──
     Klaviyo nie ma closeForm; eventy klaviyoForms są obserwacyjne → na nich
     budujemy TĘ SAMĄ pamięć (cap/done) i te same eventy GA4 co dla B. */
  function openA(reason) {
    if (!FLYOUT_ID) return;
    state.shown = true;
    /* 12.09 wieczór: zakładki NIE chowamy tutaj — robi to handler klaviyoForms 'open'. Przy zablokowanym Klaviyo
       (adblock) flyout nigdy się nie otworzy i zakładka musi zostać (audyt: klik = pusta strona bez zakładki). */
    window._klOnsite = window._klOnsite || [];
    ACTIVE_FLYOUT = offerFlyoutId();
    window._klOnsite.push(['openForm', ACTIVE_FLYOUT]);
    state.pendingOpenReason = reason || 'auto';
    /* 20.10: formularz B testu oferty nie otworzył się w 4 s przy działającym Klaviyo (nieopublikowany, usunięty,
       zła nazwa) -> otwieramy obecny formularz, żeby klik i automat nigdy nie kończyły się niczym */
    if (ACTIVE_FLYOUT !== FLYOUT_ID) {
      setTimeout(function () {
        if (state.aOpened || state.open || ACTIVE_FLYOUT === FLYOUT_ID || klaviyoFormsBlocked()) return;
        track('sv_popup_skipped', { reason: 'offer_form_missing' });
        ACTIVE_FLYOUT = FLYOUT_ID;
        window._klOnsite.push(['openForm', FLYOUT_ID]);
      }, 4000);
    }
    /* 12.09 wieczór: blokery reklam (EasyPrivacy = Opera, Brave, uBlock, AdGuard) tną static-tracking.klaviyo.com,
       gdzie leży główny skrypt formularzy Klaviyo → flyout nigdy się nie otworzy, a klientka kliknęła zakładkę.
       Fallback TYLKO po kliknięciu (nie dla automatów): po 1,5 s bez potwierdzenia otwarcia i przy Klaviyo bez
       załadowanego modułu formularzy otwieramy własny formularz (B); zapis idzie przez a.klaviyo.com/client,
       którego listy nie blokują (sprawdzone na live 12.09). */
    state.aOpened = false;
    if (reason === 'teaser') {
      setTimeout(function () {
        if (state.aOpened || state.open) return;
        if (!klaviyoFormsBlocked()) return;
        state.fallback = true;
        track('sv_popup_skipped', { reason: 'klaviyo_blocked' });
        openB('teaser_fallback');
      }, 1500);
    }
  }
  /* Klaviyo po załadowaniu modułu formularzy podmienia _klOnsite.push na własną metodę; natywny Array.push
     po 1,5 s od kliknięcia = moduł nie doszedł (zablokowany) */
  function klaviyoFormsBlocked() {
    try { return !!window._klOnsite && window._klOnsite.push === Array.prototype.push; } catch (e) { return false; }
  }
  /* e-mail z formy Klaviyo: wg dokumentacji niesie go `submit` (metaData.$email),
     ale przy formach wielokrokowych bywa najpierw w `stepSubmit` — łapiemy z obu,
     w dowolnej kolejności, i wysyłamy wspólny event zapisu dokładnie raz. */
  var aEmail = '', aSubmitted = false, aEmailDone = false;
  function emailCaptured(em) {
    if (aEmailDone) return;
    aEmailDone = true;
    markDone();
    teaser.hidden = true;
    track('sv_popup_email', { action: 'submitted' });
    sendSignupA(em);
  }
  function metaEmail(md) {
    if (!md) return '';
    return md.$email || md.email || '';
  }
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || !d.formId || (d.formId !== FLYOUT_ID && d.formId !== OFFER_FLYOUT)) return;
    if (VARIANT !== 'A') return; /* flyout otwarty poza naszym A (np. natywny timing na stagingu) = nie liczymy */
    if (d.type === 'open') {
      state.aOpened = true;
      teaser.hidden = true;
      track('sv_popup_open', { reason: state.pendingOpenReason || 'klaviyo' });
      state.pendingOpenReason = '';
    } else if (d.type === 'close') {
      if (getLS(KEY_DONE) !== '1') {
        setHideCap();
        setTimeout(showTeaser, 300);
      }
      track('sv_popup_close', { reason: 'x' });
    } else if (d.type === 'submit') {
      /* 12.09: formularz może mieć krok 2 (telefon). E-mail Klaviyo zapisuje już przy kroku 1 (stepSubmit),
         więc zapis liczymy przy PIERWSZYM zdarzeniu z e-mailem; submit tylko domyka (bez podwójnego eventu). */
      aSubmitted = true;
      var em = metaEmail(d.metaData) || aEmail;
      if (em) emailCaptured(em);
      else if (!aEmailDone) { markDone(); teaser.hidden = true; track('sv_popup_email', { action: 'submitted_no_email' }); }
    } else if (d.type === 'stepSubmit') {
      var md = d.metaData || {};
      var emStep = metaEmail(md);
      if (emStep) { aEmail = emStep; emailCaptured(emStep); }
      if (md.phone_number || md.$phone_number) track('sv_popup_phone', { action: 'submitted' });
    }
  });

  /* 12.09.2026: żaden automat (delay/scroll/exit) nie otwiera popupu nad otwartym koszykiem, menu ani lupą —
     czeka do zamknięcia overlayu (max 90 s). Audyt: B otwierał się nad koszykiem w 12. sekundzie. */
  function overlayOpen() {
    try {
      var b = document.body.className || '';
      if (/(^|\s)overflow-hidden(\s|$)/.test(b) || b.indexOf('overflow-hidden-') !== -1) return true;
      if (document.querySelector('cart-drawer.active, .section-header.menu-open, .section-header details[open]')) return true;
    } catch (e) {}
    return false;
  }
  var deferUntil = 0;
  function open(reason) {
    if (reason !== 'teaser' && reason !== 'force' && reason !== 'editor' && overlayOpen()) {
      if (!deferUntil) deferUntil = Date.now() + 90000;
      if (Date.now() < deferUntil) { setTimeout(function () { open(reason); }, 700); return; }
      deferUntil = 0; return;
    }
    deferUntil = 0;
    if (VARIANT === 'A') openA(reason); else openB(reason);
  }

  root.querySelector('[data-svgp-close]').addEventListener('click', function () { closeB('x'); });
  root.querySelector('[data-svgp-done-close]').addEventListener('click', function () { closeB('done'); });
  teaser.querySelector('[data-svgp-teaser-open]').addEventListener('click', function () { open('teaser'); });
  teaser.querySelector('[data-svgp-teaser-x]').addEventListener('click', function (e) {
    e.stopPropagation();
    teaser.hidden = true;
    setHideCap();
    try { window.sessionStorage.setItem(KEY_TEASER_OFF, '1'); } catch (e) {}
    track('sv_popup_close', { reason: 'teaser_x' });
  });
  /* Na stagingu natywny flyout ma jeszcze własny timing — jego NIEWIDOCZNE kontenery (display none/opacity 0)
     potrafią trzymać pointer-events nad naszym teaserem. Dopóki kontener Klaviyo jest niewidoczny,
     zdejmujemy mu pointer-events; gdy staje się widoczny (wariant A otwiera flyout) — przywracamy. */
  function neutralizeKlaviyoGhosts() {
    try {
      document.querySelectorAll('div[class*="kl-private-reset"], div[class*="kl-teaser-"]').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        var ghost = cs.display === 'none' || parseFloat(cs.opacity) === 0 || cs.visibility === 'hidden';
        el.style.pointerEvents = ghost ? 'none' : '';
      });
    } catch (e) {}
  }
  /* perf 30.09 B-14: zamiast setInterval(…, 700) przez całą wizytę na każdej stronie (lab 30.09 ×4: 21 elementów Klaviyo,
     0 z position:fixed, 6 ms na tik przy czystym stylu, 76–80 ms gdy styl jest „brudny”) — sprawdzamy tylko wtedy,
     gdy duch może się pojawić: zdarzenia formularzy Klaviyo (open/close/…) i pokazanie naszej zakładki. */
  function ghostBurst() { [0, 400, 1200].forEach(function (ms) { setTimeout(neutralizeKlaviyoGhosts, ms); }); }
  window.addEventListener('klaviyoForms', ghostBurst);
  ghostBurst();

  /* ── Klaviyo client API (public key, bez sekretów) ── */
  function klPost(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KL_COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
      body: JSON.stringify(payload)
    });
  }
  function withTimeout(promises, ms) {
    return Promise.race([
      Promise.allSettled(promises),
      new Promise(function (res) { setTimeout(res, ms); })
    ]);
  }
  function settledOk(settled, idx) {
    if (!settled) return 'unknown';
    var s = settled[idx];
    return (s.status === 'fulfilled' && s.value && s.value.ok) ? 'ok' : 'fail';
  }

  /* ── wspólny licznik zapisów A i B ──
     Event „SkinVibe Popup Signup" leci dla OBU wariantów, żeby liczba zapisów miała
     jedno źródło (A ma dodatkowo własny licznik formy w Klaviyo). Dla A wysyłamy
     WYŁĄCZNIE event — subskrypcję listy robi sam flyout — i NIE stemplujemy naszych
     wersji zgód: dowodem zgody dla A jest formularz Klaviyo, nie nasz popup. */
  function signupProps(variant, source, goal, extra) {
    return Object.assign({
      popup_source: source,
      popup_variant: variant,
      popup_goal: goal
    }, extra || {}, utmProps());
  }
  function postSignupEvent(email, props) {
    return klPost('events', {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'SkinVibe Popup Signup' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        }
      }
    });
  }

  /* 'ok' | 'fail' | 'unknown' — fail = WIEMY, że subskrypcja nie weszła (adblock/offline/4xx) */
  function saveEmail(email) {
    if (!KL_COMPANY || !KL_LIST) return Promise.resolve('ok');
    var props = signupProps('B', state.fallback ? 'fullscreen-fallback-adblock' : 'fullscreen-v1', state.goal || 'brak', {
      consent_email: true,
      consent_email_text_version: V_EMAIL,
      consent_email_at: new Date().toISOString(),
      popup_offer: OFFER,
      popup_offer_arm: OFFER_ARM || '',
      popup_teaser: TEASER_STYLE || ''
    });
    var sub = klPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Popup SkinVibe B fullscreen',
          profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: KL_LIST } } }
      }
    });
    var ev = postSignupEvent(email, props);
    return withTimeout([sub, ev], 3500).then(function (settled) { return settledOk(settled, 0); });
  }

  /* Wariant A: ten sam event zapisu, raz na przeglądarkę. Guard ustawiamy PRZED wysyłką
     (idempotencja ważniejsza niż jeden zgubiony event przy błędzie sieci). */
  var KEY_A_SIGNUP = 'sv_popup_a_signup_sent';
  function sendSignupA(email) {
    if (VARIANT !== 'A' || !KL_COMPANY) return;
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return;
    if (getLS(KEY_A_SIGNUP) === '1') return;
    setLS(KEY_A_SIGNUP, '1');
    try {
      postSignupEvent(email, signupProps('A', 'flyout ' + (ACTIVE_FLYOUT || FLYOUT_ID), null, {
        popup_teaser: TEASER_STYLE || '',
        popup_offer: ACTIVE_FLYOUT && ACTIVE_FLYOUT === OFFER_FLYOUT ? (OFFER_PHASE2 ? 'bw_weeks' : 'bw_early') : OFFER,
        popup_offer_arm: OFFER_ARM || ''
      }))
        .then(null, function () {});
    } catch (e) {}
  }

  /* Telefon: zgoda SMS marketing (lista single opt-in popupu) + event z dowodem zgody.
     Treść zgody wymienia SMS i WhatsApp — whatsapp_consent zapisujemy jako property
     (kanał WhatsApp w Klaviyo włączamy osobno, gdy będzie plan Mobile Messaging). */
  function savePhone(email, phone) {
    if (!KL_COMPANY) return Promise.resolve('ok');
    var now = new Date().toISOString();
    var props = {
      popup_source: 'fullscreen-v1',
      popup_variant: 'B',
      phone_consent: true,
      sms_consent: true,
      whatsapp_consent: true,
      phone_consent_channels: 'sms_whatsapp',
      phone_consent_text_version: V_PHONE,
      phone_consent_at: now,
      phone_consent_number: phone
    };
    var ev = klPost('events', {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'SkinVibe Popup Phone Consent' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        }
      }
    });
    var sub;
    if (KL_SMS_LIST) {
      sub = klPost('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Popup SkinVibe B fullscreen (telefon)',
            profile: { data: { type: 'profile', attributes: {
              email: email,
              phone_number: phone,
              /* zgoda nazywa oba kanaly (popup-tel-v1) -> zapis SMS + WhatsApp w jednym wywolaniu (27.08.2026) */
              subscriptions: {
                sms: { marketing: { consent: 'SUBSCRIBED' } },
                whatsapp: { marketing: { consent: 'SUBSCRIBED' } }
              }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: KL_SMS_LIST } } }
        }
      });
    } else {
      sub = klPost('profiles', { data: { type: 'profile', attributes: { email: email, phone_number: phone } } });
    }
    /* decyduje subskrypcja (numer musi być poprawny dla Klaviyo); event = dowód, best effort */
    return withTimeout([sub, ev], 3500).then(function (settled) { return settledOk(settled, 0); });
  }

  /* ── krok 1: cele ── */
  root.querySelectorAll('[data-svgp-goal]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.goal = btn.getAttribute('data-svgp-goal') || '';
      track('sv_popup_goal', { goal: state.goal });
      go('email');
    });
  });

  /* ── krok 2: e-mail ── */
  var formEmail = root.querySelector('[data-svgp-form-email]');
  var inpEmail = root.querySelector('[data-svgp-email]');
  var cbEmail = root.querySelector('[data-svgp-consent-email]');
  var errEmail = root.querySelector('[data-svgp-email-err]');
  var btnEmail = root.querySelector('[data-svgp-email-submit]');
  var emailLabel = btnEmail ? btnEmail.textContent : '';

  formEmail.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (inpEmail.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      errEmail.textContent = 'Wpisz poprawny adres e-mail.';
      inpEmail.setAttribute('aria-invalid', 'true');
      inpEmail.focus();
      return;
    }
    if (!cbEmail.checked) {
      errEmail.textContent = 'Zaznacz zgodę, żebyśmy mogli wysłać Ci kod.';
      cbEmail.focus();
      return;
    }
    errEmail.textContent = '';
    inpEmail.setAttribute('aria-invalid', 'false');
    state.email = email;
    btnEmail.disabled = true;
    btnEmail.textContent = 'Zapisuję...';
    track('sv_popup_email', { action: 'submitted', goal: state.goal });
    saveEmail(email).then(function (res) {
      btnEmail.disabled = false;
      btnEmail.textContent = emailLabel;
      if (res === 'fail') {
        errEmail.textContent = 'Nie udało się zapisać. Sprawdź internet lub wyłącz blokadę reklam i spróbuj ponownie.';
        track('sv_popup_email', { action: 'save_failed', goal: state.goal });
        return;
      }
      markDone();
      /* lead pod przyszły custom pixel: TYLKO Shopify.analytics (e-mail nie może trafić do GA4/dataLayer) */
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('skinvibe_popup_lead', { email: email, goal: state.goal, variant: 'B' });
        }
      } catch (err) {}
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
      go('phone');
    });
  });

  /* ── krok 3: telefon ── */
  var formPhone = root.querySelector('[data-svgp-form-phone]');
  var inpPhone = root.querySelector('[data-svgp-phone]');
  var cbPhone = root.querySelector('[data-svgp-consent-phone]');
  var errPhone = root.querySelector('[data-svgp-phone-err]');
  var btnPhone = root.querySelector('[data-svgp-phone-submit]');
  var skipBtn = root.querySelector('[data-svgp-skip]');
  var phoneLabel = btnPhone ? btnPhone.textContent : '';

  function normalizePhone(raw) {
    var d = (raw || '').replace(/[^0-9]/g, '');
    if (d.indexOf('0048') === 0) d = d.slice(4);
    else if (d.indexOf('48') === 0 && d.length === 11) d = d.slice(2);
    if (d.length === 9 && /^[45678]/.test(d)) return '+48' + d;
    return null;
  }

  formPhone.addEventListener('submit', function (e) {
    e.preventDefault();
    var phone = normalizePhone(inpPhone.value);
    if (!phone) {
      errPhone.textContent = 'Wpisz polski numer komórkowy (9 cyfr).';
      inpPhone.setAttribute('aria-invalid', 'true');
      inpPhone.focus();
      return;
    }
    if (!cbPhone.checked) {
      errPhone.textContent = 'Zaznacz zgodę na wiadomości albo pomiń ten krok.';
      cbPhone.focus();
      return;
    }
    errPhone.textContent = '';
    inpPhone.setAttribute('aria-invalid', 'false');
    btnPhone.disabled = true;
    btnPhone.textContent = 'Zapisuję...';
    track('sv_popup_phone', { action: 'submitted' });
    savePhone(state.email, phone).then(function (res) {
      btnPhone.disabled = false;
      btnPhone.textContent = phoneLabel;
      if (res === 'fail') {
        errPhone.textContent = 'Nie udało się zapisać numeru. Sprawdź numer i spróbuj ponownie albo pomiń ten krok.';
        track('sv_popup_phone', { action: 'save_failed' });
        return;
      }
      go('done');
    });
  });

  skipBtn.addEventListener('click', function () {
    track('sv_popup_phone', { action: 'skipped' });
    go('done');
  });

  /* ── triggery (wspólne dla A i B) ── */
  function shouldAutoShow() {
    if (EXCLUDED) return false;
    if (getLS(KEY_DONE) === '1') return false;
    var until = parseInt(getLS(KEY_HIDE) || '0', 10);
    if (until && Date.now() < until) return false;
    return true;
  }

  /* istniejący profil Klaviyo = nie pokazujemy (odpowiednik „Don't show to existing profiles") */
  function guardIdentified(cb) {
    var done = false;
    function finish(identified) { if (done) return; done = true; cb(!!identified); }
    if (!SKIP_IDENTIFIED) { finish(false); return; }
    try {
      if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        window.klaviyo.isIdentified().then(finish, function () { finish(false); });
        setTimeout(function () { finish(false); }, 1200);
      } else { finish(false); }
    } catch (e) { finish(false); }
  }

  function preloadHero() {
    if (VARIANT !== 'B') return;
    try {
      var land = window.matchMedia && window.matchMedia('(orientation: landscape)').matches;
      var src = root.getAttribute(land ? 'data-bg-desktop' : 'data-bg-mobile');
      if (src) { var im = new Image(); im.src = src; }
    } catch (e) {}
  }

  /* Triggery: A zawsze 1:1 jak natywny flyout (teaser 2 s + exit intent + klik).
     B wg trybu: 'teaser_first' = jak flyout; 'auto' (hybryda, default od 25.08) = teaser 2 s
     od decyzji cookie + auto-open po delay/scrollu + exit intent. Test A/B jest GLOBALNY:
     caly nowy system vs obecny flyout (decyzja CEO 25.08). */
  function armTriggers() {
    if (!consentDecided()) { onConsentDecided(armTriggers); return; }
    preloadHero();
    var fired = false;
    var armedAt = Date.now();
    var delay = IS_MOBILE ? DELAY_M : DELAY;
    if (isNaN(delay)) delay = 8;
    var timer = null, teaserTimer = null;
    function fire(reason) {
      if (fired) return;
      fired = true; cleanup();
      /* 19.10: zapis w sekcji sv-zapis (stopka) na tej samej stronie ustawia sv_popup_v1_done po uzbrojeniu automatów */
      if (getLS(KEY_DONE) === '1') return;
      guardIdentified(function (identified) {
        if (identified) { track('sv_popup_skipped', { reason: 'identified' }); return; }
        open(reason);
      });
    }
    function onScrollAuto() {
      if (fired) return;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH <= 0) return;
      var pct = (window.scrollY || window.pageYOffset || 0) / docH * 100;
      if (pct >= SCROLL_PCT) fire('scroll');
    }
    function onLeave(e) {
      if (fired) return;
      if (e.clientY <= 0 && Date.now() - armedAt > 3000) fire('exit');
    }
    /* mobile exit-intent (odpowiednik Klaviyo „quick upward scroll"): >=120 px w górę w <250 ms
       po zjechaniu min. 300 px; nie wcześniej niż 3 s od uzbrojenia */
    var lastY = window.scrollY || 0, lastT = Date.now(), maxY = lastY;
    function onScrollExit() {
      if (fired) return;
      var y = window.scrollY || 0, t = Date.now();
      if (y > maxY) maxY = y;
      if (maxY >= 300 && lastY - y >= 120 && t - lastT <= 250 && t - armedAt > 3000) fire('exit');
      lastY = y; lastT = t;
    }
    function cleanup() {
      clearTimeout(timer); clearTimeout(teaserTimer);
      window.removeEventListener('scroll', onScrollAuto);
      window.removeEventListener('scroll', onScrollExit);
      document.removeEventListener('mouseleave', onLeave);
    }
    /* Tryb dotyczy TYLKO wariantu B (decyzja CEO 25.08: test globalny — nowy system vs obecny).
       A ZAWSZE odtwarza natywny flyout 1:1 (teaser + exit intent + klik).
       B 'auto' = hybryda wg benchmarków (Wisepops/Omnisend/Klaviyo): teaser od wejścia (tryb "both"),
       auto-open po delay OD DECYZJI COOKIE albo scrollu — co pierwsze; exit intent jako dopalacz. */
    var effMode = (VARIANT === 'A') ? 'teaser_first' : MODE;
    teaserTimer = setTimeout(showTeaser, Math.max(0, TEASER_DELAY) * 1000);
    if (effMode === 'auto') {
      timer = setTimeout(function () { fire('delay'); }, Math.max(0, delay) * 1000);
      window.addEventListener('scroll', onScrollAuto, { passive: true });
    }
    if (EXIT_INTENT) {
      if (FINE_POINTER) document.addEventListener('mouseleave', onLeave);
      else window.addEventListener('scroll', onScrollExit, { passive: true });
    }
  }

  /* ── atrybucja przychodu: atrybut koszyka sv_ab ──
     Po PIERWSZYM udanym dodaniu do koszyka zapisujemy przydzielony wariant w atrybutach
     koszyka (Shopify Flow → tag zamówienia). Źródłem prawdy jest WYŁĄCZNIE zapisany
     przydział (localStorage sv_popup_ab) — podglądy ?sv_popup=a|b i cohort „excluded"
     (blog, bez losowania) nie oznaczają koszyka, żeby nie zatruć atrybucji.
     Zero dodatkowych żądań przy zwykłym przeglądaniu: nasłuch = wrapper na window.fetch
     (motyw Olivia i wszystkie apki w motywie dodają do koszyka przez fetch — sprawdzone),
     żądanie leci tylko po odpowiedzi 200 z /cart/add. Guard: wariant + token koszyka
     (cookie `cart`), więc nowy koszyk w tej samej sesji dostaje atrybut ponownie.
     `attributes` w /cart/update.js SCALA się z istniejącymi — wysyłamy tylko nasze klucze (sv_ab, od 02.10 też sv_teaser). */
  var KEY_CART_TAG = 'sv_ab_cart_tagged';
  function sess(fn, dflt) { try { return fn(); } catch (e) { return dflt; } }
  function assignedVariant() {
    var s = getLS(KEY_AB);
    return (s === 'A' || s === 'B') ? s : null;
  }
  function cartToken() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
      return m ? m[1] : '';
    } catch (e) { return ''; }
  }
  function cartRoot() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return r || '/';
    } catch (e) { return '/'; }
  }
  /* 02.10.2026: ten sam znacznik niesie też grupę testu wyglądu teasera (sv_teaser), tylko w trakcie testu
     (udział narożnika 1-99) i tylko z zapisanego losowania, nie z podglądu ?sv_teaser= */
  function assignedTeaser() { return teaserTestOn() ? storedTeaserStyle() : ''; }
  /* 20.10.2026: i grupę testu oferty (sv_offer), tylko w oknie testu i tylko z zapisanego losowania */
  function assignedOffer() { return offerTestOn() ? storedOffer() : ''; }
  function tagCartVariant() {
    var v = assignedVariant(), t = assignedTeaser(), o = assignedOffer();
    if (!v && !t && !o) return;
    var attrs = {};
    if (v) attrs.sv_ab = v;
    if (t) attrs.sv_teaser = t;
    if (o) attrs.sv_offer = o;
    var stamp = (v || '-') + '|' + (t || '-') + '|' + (o || '-') + '|' + cartToken();
    if (sess(function () { return window.sessionStorage.getItem(KEY_CART_TAG); }) === stamp) return;
    sess(function () { window.sessionStorage.setItem(KEY_CART_TAG, stamp); });
    function undo() { sess(function () { window.sessionStorage.removeItem(KEY_CART_TAG); }); }
    try {
      window.fetch(cartRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: attrs }),
        /* keepalive: gdy motyw po dodaniu przeladuje strone na /cart, zadanie i tak dojdzie */
        keepalive: true
      }).then(function (res) { if (!res || !res.ok) undo(); }, undo);
    } catch (e) { undo(); }
  }
  function isCartAdd(url) {
    if (!url || url.indexOf('/cart/add') === -1) return false;
    if (url.charAt(0) === '/') return true;
    try { return url.indexOf(window.location.origin) === 0; } catch (e) { return false; }
  }
  /* Inne skrypty motywu/apek też nadpisują window.fetch (25.08: apka wrapowała fetch PO nas,
     kopią oryginału sprzed naszego wrappera — nasz hook był omijany). Dlatego wrapper
     zakładamy na AKTUALNY window.fetch i ponawiamy po DOMContentLoaded/load i z opóźnieniem;
     marker __svAb chroni przed podwójnym owinięciem tego samego obiektu, a guard w
     tagCartVariant — przed podwójnym /cart/update.js, gdyby wrapper i tak zagnieździł się 2×. */
  function installFetchHook() {
    try {
      var cur = window.fetch;
      if (typeof cur !== 'function' || cur.__svAb) return;
      var wrapped = function (input, init) {
        var out = cur.apply(this, arguments);
        try {
          var url = '';
          if (typeof input === 'string') url = input;
          else if (input && typeof input.url === 'string') url = input.url;
          if (isCartAdd(url) && out && typeof out.then === 'function') {
            out = out.then(function (res) {
              try { if (res && res.ok) tagCartVariant(); } catch (e) {}
              return res;
            });
          }
        } catch (e) {}
        return out;
      };
      wrapped.__svAb = true;
      window.fetch = wrapped;
    } catch (e) {}
  }
  function hookCartAttribution() {
    if (window.__svAbCartHooked) return;
    window.__svAbCartHooked = true;
    installFetchHook();
    try {
      document.addEventListener('DOMContentLoaded', installFetchHook);
      window.addEventListener('load', installFetchHook);
      [1500, 4000, 8000, 15000].forEach(function (ms) { setTimeout(installFetchHook, ms); });
    } catch (e) {}
  }

  function boot() {
    if (DESIGN) {
      VARIANT = 'B';
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === SECTION_ID) openB('editor');
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail && e.detail.sectionId === SECTION_ID) closeB('editor');
      });
      return;
    }
    if (!ENABLED) return;
    /* wylosowana wcześniej grupa testu teasera: od razu, żeby parametr GA4 szedł przy wszystkich zdarzeniach strony */
    if (teaserTestOn() && storedTeaserStyle() && FORCE_TEASER !== 'corner' && FORCE_TEASER !== 'tab') applyTeaserStyle(storedTeaserStyle());
    /* tak samo grupa testu oferty (bez nowego losowania: losujemy dopiero przy pokazaniu albo otwarciu) */
    if (offerTestOn() && storedOffer() && FORCE_OFFER !== 'bw' && FORCE_OFFER !== 'std') pickOffer();
    /* przypisany wcześniej wariant → user property GA4 na każdej stronie (guardrail zakupów) */
    var stored = getLS(KEY_AB);
    if (stored === 'A' || stored === 'B') ga4UserVariant(stored);
    if (FORCE === '1' || FORCE === 'reset' || FORCE === 'a' || FORCE === 'b') {
      VARIANT = pickVariant();
      ga4UserVariant(VARIANT);
      open('force');
      return;
    }
    if (!shouldAutoShow()) {
      if (getLS(KEY_DONE) !== '1' && !EXCLUDED) {
        VARIANT = pickVariant();
        showTeaser();
      }
      return;
    }
    VARIANT = pickVariant();
    if (COHORT === 'test') ga4UserVariant(VARIANT);
    armTriggers();
  }

  /* hook koszyka instalujemy od razu (boot czeka na idle do 2,5 s — użytkownik może
     kliknąć „do koszyka" wcześniej); sam tag i tak leci tylko przy zapisanym przydziale */
  if (ENABLED && !DESIGN) hookCartAttribution();

  if (window.requestIdleCallback) window.requestIdleCallback(boot, { timeout: 2500 });
  else setTimeout(boot, 300);
  }
  function bootAll(scope) {
    (scope || document).querySelectorAll('[data-svgp-root]').forEach(initSvGoalPopup);
  }
  bootAll();
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
  }
})();
